export default {
    methods: {
        formatDate(epoch) {
            // Seconds to milliseconds
            const date = new Date(epoch * 1000)
            return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear()
        },
        hasData(data) {
            if (!data.hasOwnProperty('data')) {
                return false;
            }
            if (Array.isArray(data.data) && data.data.length || 
                (typeof (data.data) === 'object' && Object.keys(data.data).length)) {
                    return true;
                }
            return false;
        }
    }
};